import { render } from "./ConfirmRemove.vue?vue&type=template&id=bf8555f2"
import script from "./ConfirmRemove.vue?vue&type=script&lang=js"
export * from "./ConfirmRemove.vue?vue&type=script&lang=js"

import "./ConfirmRemove.vue?vue&type=style&index=0&id=bf8555f2&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__